const t = (input: string) => {
  return input;
};
export default t;
export const wrappers: { openingWrapper: string; closingWrapper: string; quote: string; openingParenthesis: string; closingParenthesis: string } = {
  openingWrapper: "[",
  closingWrapper: "]",
  quote: `"`,
  openingParenthesis: `(`,
  closingParenthesis: `)`,
};
